// GradeHelper.js (optional - best: keep in one place and import in both screens)
// If you don't want separate file, you can copy-paste this block in both components.

export const EVALUATED_BY = {
  MARKS: 'MARKS',
  GRADE: 'GRADE',
};

// ✅ One place to change grades
export const GRADE_MASTER = {
  A_PLUS: 'A+',
  A: 'A',
  B_PLUS: 'B+',
  B: 'B',
  C_PLUS: 'C+',
  C: 'C',
  D: 'D',
  E: 'E',
  F: 'F',
};

export const gradeOptions = Object.values(GRADE_MASTER).map((g) => ({
  value: g,
  label: g,
}));

export const normalizeGrade = (v) => String(v ?? '').trim();

export const gradeToOption = (v) => {
  const s = normalizeGrade(v);
  return gradeOptions.find((o) => o.value === s) || null;
};

export const evaluatedByOptions = [
  { value: EVALUATED_BY.MARKS, label: 'Marks' },
  { value: EVALUATED_BY.GRADE, label: 'Grade' },
];
